// extracted by mini-css-extract-plugin
module.exports = {"formInput":"input_formInput__2KZ1B","error":"input_error__nCcZc"};